// These class names are read by the GTM container's trigger configuration —
// they are not styling hooks. Renaming or removing a value here is a silent
// breaking change (no test, lint, or runtime failure); coordinate with the
// GTM container config before changing any value.
const GTM_CLASSNAMES = {
	YOUTUBE_VIDEO_WRAPPER: 'youtube-video__wrapper',
	CITY_LINK: 'near-by-cities__link',
	FEATURED_CONTENT_CARD_LINK: 'featured-content-card__link',
	PSP_LINKS_CARD_LINK: 'psp-links-card__link',
	REVIEW_CARD_LINK: 'review-card__link',
	REVIEWS_FOOTER_LINK: 'reviews-footer__link',
};

export default GTM_CLASSNAMES;
